<template>
  <search-group  @search="findData" @clear="clearValue" :span="24" :inline="true" :multipleLines="true"
                :btnOffset="18" :btnSpan="6">
    <Row :gutter="16">
      <Col span="6" :sm="6" :lg="4">
        <Select v-model="searchData.projectFid" placeholder="请选择项目" @on-change="changeProject">
          <Option value="100" v-for="item in projectList" :value="item.value" :key="item.value">{{item.text}}</Option>
        </Select>
      </Col>
      <Col span="4" :sm="4" :lg="3">
        <Select v-model="searchData.visitZo" placeholder="回访人">
          <Option value="">{{searchData.projectFid==='' ? '请先选择项目':'请选择'}}</Option>
          <Option value="100" v-for="item in zoList" :value="item.value" :key="item.value">{{item.text}}
          </Option>
        </Select>
      </Col>
      <Col span="7" :sm="7" :lg="7">
        <DatePicker class="block" type="daterange" style="width:100%" split-panels placeholder="应回访日期"
                    v-model="shouldVisitDate" @on-change="getShouldVisitDate"></DatePicker>
      </Col>
      <Col span="7" :sm="7" :lg="7">
        <DatePicker class="block" type="daterange" style="width:100%" split-panels placeholder="实际回访日期"
                    v-model="visitDate" @on-change="getVisitDate"></DatePicker>
      </Col>
      <Col span="4" :sm="4" :lg="3">
        <Select v-model="searchData.visitStatus" placeholder="回访状态">
          <Option value="">请选择</Option>
          <Option value="100" v-for="item in visitStatusList" :value="item.value" :key="item.value">{{item.text}}
          </Option>
        </Select>
      </Col>
    </Row>
    <Row :gutter="16">
      <Col span="4">
        <Input
          v-model="searchData.contractCode"
          placeholder="合同号"></Input>
      </Col>
      <Col span="4">
        <Select class="width100"
                filterable
                remote
                :remote-method="findRoomList"
                v-model="searchData.stockFid"
                placeholder="房间/床位号"
                :not-found-text="''"
        >
          <Option v-for="item in roomList" :value="item.value" :key="'keyHH'+item.value">{{item.text}}</Option>
        </Select>
      </Col>
    </Row>
  </search-group>
</template>

<script type="text/ecmascript-6">

  // import SearchGroup from 'components/SearchGroup/index';
  import {fuzzyRoom} from 'api/functionalArea';
  import {getVisitStatus} from 'api/workBench'
  import {getProjects,getProjectZos} from "../../../../api/common";

  export default {

    components: {
      // SearchGroup
    },

    watch: {
    },

    data() {
      return {
        projectList: [],
        isFirstChang: true,
        loading: false,
        searchData: {
          projectFid: '',
          shouldVisitDateFrom: '',
          shouldVisitDateTo: '',
          visitDateFrom: '',
          visitDateTo: '',
          visitStatus: '',
          visitZo: '',
          contractCode: '',
          stockFid: '',
          page: 1,
          limit: 10
        },
        roomList: [],
        shouldVisitDate: [],
        visitDate: [],
        visitStatusList: [],
        zoList: []
      }
    },
    methods: {
      findData() {
        this.$emit('findData', this.searchData);
      },
      clearValue() {
        this.shouldVisitDate = [];
        this.visitDate = [];
        this.searchData = {
          projectFid: '',
          shouldVisitDateFrom: '',
          shouldVisitDateTo: '',
          visitDateFrom: '',
          visitDateTo: '',
          visitStatus: '',
          contractCode: '',
          stockFid: '',
          page: 1,
          limit: 10
        }
      },

      getShouldVisitDate(value) {
        this.searchData.shouldVisitDateFrom = value[0]
        this.searchData.shouldVisitDateTo = value[1]
      },

      getVisitDate(value) {
        this.searchData.visitDateFrom = value[0]
        this.searchData.visitDateTo = value[1]
      },

      findRoomList(query) {
        if (query !== '' && this.searchData.projectFid !== '') {
          let params = {
            projectid: this.searchData.projectFid,
            roomnumber: query
          }
          fuzzyRoom(params).then(res => {
            this.loading = false;
            this.roomList = res.data;
          })
        } else {
          this.roomList = [];
          this.searchData.stockFid = ''
        }
      },
      changeProject(value) {
        if(value !==''){
          this.getProjectZos(value)
        } else{
          this.zoList =[]
        }
      },
      getProjectZos(projectFid) {
        getProjectZos(projectFid).then( res => {
          this.zoList = res.data
        }).catch(error => {
        });
      },
    },
    activated(){
      if (this.$route.params.visitStatus) {
        this.searchData.visitStatus = this.$route.params.visitStatus
      }
      if(this.$route.params.projectFid) {
        this.searchData.projectFid = this.$route.params.projectFid;
      }
      this.$emit('findData', this.searchData);


    },
    created() {
      if (this.$route.params.visitStatus) {
        this.searchData.visitStatus = this.$route.params.visitStatus
      }
      if(this.$route.params.projectFid) {
          this.searchData.projectFid = this.$route.params.projectFid;
      }
      getVisitStatus().then(res => {
        res.data && (this.visitStatusList = res.data.visitStatus)
      }).catch(error => {

      });
      getProjects().then(res => {
        if (!res.data) {
          return
        }
        this.projectList = res.data
        if (this.projectList.length) {
            if(!this.searchData.projectFid) {
              this.searchData.projectFid = this.projectList[0].value
            }
        }
        this.$emit('findData', this.searchData);
      }).catch(error => {
      })

    }
  }
</script>
<style scoped>
  .dash {
    text-align: center;
  }

  .dash span {
    display: inline-block;
    width: 60%;
    height: 2px;
    background: #dddee1;
    vertical-align: sub;
  }

  .ivu-col {
    margin-bottom: 16px;
  }

  .date-picker .ivu-col {
    margin-bottom: 0
  }
</style>

